"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePagination = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _hooks = require("../hooks");

var usePagination = function usePagination(_ref) {
  var loadPageData = _ref.loadPageData;

  var _useState = (0, _react.useState)(1),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedPage = _useState2[0],
      setSelectedPage = _useState2[1];

  var asyncFunction = (0, _react.useCallback)(function () {
    return loadPageData(selectedPage);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedPage]);

  var _useAsync = (0, _hooks.useAsync)(asyncFunction, [selectedPage]),
      pageData = _useAsync.data,
      isLoading = _useAsync.isLoading,
      error = _useAsync.error;

  var paginationProps = {
    selectedPage: selectedPage,
    onPageSelect: setSelectedPage
  };
  return {
    paginationProps: paginationProps,
    pageData: pageData,
    isLoading: isLoading,
    error: error
  };
};

exports.usePagination = usePagination;